import { call, select, takeEvery } from 'redux-saga/effects';
import { CallEffect, put, SelectEffect } from '@redux-saga/core/effects';
import { AnyAction } from 'redux';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../localStore';
import { LocalActions, vnAddressInvalidPageRequested } from '../local.actions';

const globalActions = new GlobalActions();

type GeneratorType = SelectEffect | AnyAction | CallEffect;
export function* vnAddressInvalidSaga(): Generator<GeneratorType> {
  yield takeEvery(LocalActions.VN_ADDRESS_INVALID, requestVnAddressInvalidPage);
  yield takeEvery(LocalActions.VN_ADDRESS_INVALID_CONFIRMED, openShop);
}

export function* requestVnAddressInvalidPage(): Generator<GeneratorType> {
  yield put(vnAddressInvalidPageRequested());
}

export function* openShop(): Generator<GeneratorType> {
  const globalPut = GlobalPut.getInstance();
  const appState: IAppState = (yield select()) as IAppState;

  yield call(
    globalPut.put,
    globalActions.einstiegSuccessful(appState.transientState.vnAddressInvalid.einstiegResponse),
  );
  yield call(globalPut.put, globalActions.einstiegWithInvalidAddress());
}
